import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data));
  }, []);

  const cards = [
    { label: "Works", value: stats?.works ?? "—", href: "/admin/works" },
    { label: "Inquiries", value: stats?.inquiries ?? "—", href: "/admin/inquiries" },
    { label: "Unread", value: stats?.unread_inquiries ?? "—", accent: true, href: "/admin/inquiries" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <p className="overline mb-4">Overview</p>
      <h1 className="font-display text-4xl md:text-5xl tracking-tighter mb-12">Dashboard</h1>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {cards.map((c) => (
          <a
            key={c.label}
            href={c.href}
            className="block bg-[#121214] border border-white/5 hover:border-[#C9A050]/40 p-8 transition-colors"
          >
            <p className="overline mb-4">{c.label}</p>
            <p className={`font-display text-6xl tracking-tighter ${c.accent ? "text-[#C9A050]" : "text-white"}`}>
              {c.value}
            </p>
          </a>
        ))}
      </div>

      <div className="mt-16 p-8 bg-[#121214] border border-white/5">
        <p className="overline mb-4">Quick actions</p>
        <div className="flex flex-wrap gap-3">
          <a href="/admin/works" className="overline border border-white/15 hover:border-[#C9A050] hover:text-[#C9A050] px-5 py-3 transition-colors">Add new work</a>
          <a href="/admin/settings" className="overline border border-white/15 hover:border-[#C9A050] hover:text-[#C9A050] px-5 py-3 transition-colors">Edit homepage content</a>
          <a href="/admin/inquiries" className="overline border border-white/15 hover:border-[#C9A050] hover:text-[#C9A050] px-5 py-3 transition-colors">Review inquiries</a>
        </div>
      </div>
    </div>
  );
}
